import angular from 'angular'
import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import {
  QuickReceipt,
  QuickReceiptListItem,
  QuickReceiptDateItem,
  QuickReceiptRegisterItem,
} from '../quick-receipt/QuickReceipt'

interface CashMovementData {
  amount: string
  date: string
  note?: string
  type: string
  username: string
}

interface CashMovementReceiptProps {
  data: CashMovementData
}

export const CashMovementReceipt: React.FC<CashMovementReceiptProps> = ({
  data,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()

  return (
    <QuickReceipt
      title={data.type}
      subTitle={vdCurrencyFilter(data.amount)}
      items={
        <>
          <QuickReceiptDateItem value={data.date} />
          <QuickReceiptListItem label="User" value={data.username} />
          <QuickReceiptRegisterItem />
          <QuickReceiptListItem label="Note" value={data.note || '-'} />
        </>
      }
    />
  )
}

angular
  .module('webregister.components')
  .component(
    'wrPrintCashMovementReceipt',
    reactular(CashMovementReceipt, ['data'], 'reactWrapper')
  )
